import type { ProjectileHittable } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class BlackBox extends PhysicalThing implements ProjectileHittable {
	static key = "BlackBox";
	constructor(xy: XY) {
		super(xy, true);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	onProjectileHit(_projectile: unknown): void {}

	isHittable(): boolean {
		return true;
	}

	static deserialize(data: any): BlackBox {
		const b = new BlackBox(deserializeXY(data.xy));
		b.visualId = data.visualId;
		return b;
	}
}
